import {FullSession} from '@aboutyou/grpc-clients/tadarida/aysa_api/shared/v1/session.types';
import {useMemo} from 'react';
import {
  useSimpleUserTokenOrSessionId,
  useUserTokenOrSessionId,
} from './user.selector';

export const useFullSession = (): FullSession | null => {
  const {data: tokenOrSessionId, isLoading} = useUserTokenOrSessionId();

  if (!tokenOrSessionId || isLoading) {
    return null;
  }

  if ('token' in tokenOrSessionId) {
    return {
      type: {
        $case: 'customer' as const,
        customer: {
          authToken: tokenOrSessionId.token,
        },
      },
    };
  }

  return {
    type: {
      $case: 'guest' as const,
      guest: {
        sessionId: tokenOrSessionId.sessionId,
      },
    },
  };
};

export const useOptionalSession = () => {
  const tokenOrSessionId = useSimpleUserTokenOrSessionId();

  return useMemo(() => {
    if (tokenOrSessionId && 'token' in tokenOrSessionId) {
      return {
        type: {
          $case: 'customer' as const,
          customer: {
            authToken: tokenOrSessionId.token,
          },
        },
      };
    }

    return {
      type: {
        $case: 'noSession' as const,
        noSession: {},
      },
    };
    // @ts-expect-error token is not always defined, we want the useMemo to rerun only when token is defined
  }, [tokenOrSessionId?.token, tokenOrSessionId?.sessionId]);
};

export const useAnySession = () => {
  const tokenOrSessionId = useSimpleUserTokenOrSessionId();

  return useMemo(() => {
    if (tokenOrSessionId && 'token' in tokenOrSessionId) {
      return {
        type: {
          $case: 'customer' as const,
          customer: {
            authToken: tokenOrSessionId.token,
          },
        },
      };
    }

    if (tokenOrSessionId && 'sessionId' in tokenOrSessionId) {
      return {
        type: {
          $case: 'guest' as const,
          guest: {
            sessionId: tokenOrSessionId.sessionId,
          },
        },
      };
    }

    return {
      type: {
        $case: 'noSession' as const,
        noSession: {},
      },
    };
    // @ts-expect-error token is not always defined, we want the useMemo to rerun only when token is defined
  }, [tokenOrSessionId?.token, tokenOrSessionId?.sessionId]);
};

export const useCustomerSession = () => {
  const tokenOrSessionId = useSimpleUserTokenOrSessionId();

  if (tokenOrSessionId && 'token' in tokenOrSessionId) {
    return {authToken: tokenOrSessionId.token};
  }

  return undefined;
};
